const ClubSubscriptionStatesEnum = {
	C: 'Current',
	O: 'Overdue',
	U: 'Unsubscribed',
	P: 'Pending Authorisation',
};

export default ClubSubscriptionStatesEnum